import React from 'react'

export interface FilterBoxProps {
  label: string
  value: string
  clearFunction: () => void
}

const FilterBox: React.FC<FilterBoxProps> = ({ label, value, clearFunction }) => {
  return (
    <div className="py-1 px-2 mb-2 mx-4 bg-white shadow shadow-std-light-gray-400 rounded-md items-center flex">
      <span className="text-gray-500 mr-2">{label}</span>
      <span className="text-gray-600 font-semibold mr-2">{value}</span>
      <button
        className="text-gray-400 bg-transparent border-none cursor-pointer"
        onClick={clearFunction}
      >
        X
      </button>
    </div>
  )
}

export default FilterBox
